<div *ngIf="!easArray.meta.hidden">
  <div *ngFor="let control of easArray.controls; let i=index">
    <ub-box rounded="true" dotted="true">
      <div title>
        <button (click)="remove(i)" mat-stroked-button color="warn" i18n>Remove</button>
      </div>
      <div content>
        <eas-easform-group [easGroup]="control"
                           [templates]="templates"
                           [forceDisplayReadOnly]="forceDisplayReadOnly"></eas-easform-group>
      </div>
    </ub-box>
  </div>
  <button type="button" mat-stroked-button color="primary" (click)="push()" class="button--block">
    <span *ngIf="easArray.controls.length === 0" i18n>Add options</span>
    <span *ngIf="easArray.controls.length > 0" i18n>Add another option</span>
  </button>
</div>
